import React from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import clsx from 'clsx';

import { useSelector } from 'react-redux';
import { FormInput } from '../../../../../components/index';
import { Article } from '../../../../../types/items';
import { VideoIcon } from '../../../../../components/icon/solid';
import { MediaStyles } from './styles';
import UploadProgress from './UploadProgress';
import {
  DeleteAction,
  LockAction,
  DownloadDocumentAction,
  DownloadVideoAction,
  ExportMediaAction,
  RequestMasterAction,
} from './actions/index';
import { selectArticlesMediaSubmitState } from '../../../../../store/modules/articles/selectors';
import AdvancedActionCell from '../../../../../components/action-cell/AdvancedActionCell';
import { selectIsSuperAdmin } from '../../../../../store/modules/users/selectors';
import MediaItemImage from './MediaItemImage';
import { formatDuration } from '../../../../../utility/helpers';
import { useField } from 'formik';

type Props = {
  media: Article;
  openMediaPreview: () => void;
  keyUpHandler?: (e: React.KeyboardEvent) => void;
};

const MediaVideo = ({ media, openMediaPreview, keyUpHandler = () => {} }: Props) => {
  const classes = MediaStyles();
  const submitUpdates = useSelector(selectArticlesMediaSubmitState);
  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  const { can_edit: canEdit, can_delete: canDelete, can_view: canView } = media.permissions;
  const date = new Date(media.updated * 1000);
  const title = useField('title')[0].value;

  return (
    <Grid item container xs={12} className={classes.root}>
      <div className={classes.mediaImageContainer}>
        <MediaItemImage media={media} openMediaPreview={openMediaPreview} />
        <Grid className="duration">
          {media.ref.video && media.ref.video.duration && formatDuration(media.ref.video.duration)}
        </Grid>
      </div>
      <Grid item xs={12} className={classes.title} title={title}>
        <FormInput
          name="title"
          disabled={submitUpdates || !canEdit}
          startAdornment={<VideoIcon className={clsx(classes.icon, classes.videoIcon)} />}
          classes={{ inputUnderline: classes.inputUnderline }}
          onKeyUp={keyUpHandler}
          autoComplete="off"
        />
      </Grid>
      <Grid className={classes.settingPanel} item container xs={12} alignItems="center" justify="space-between">
        <UploadProgress articleId={media.id} />
        <Tooltip classes={{ tooltip: classes.tooltip }} title={date.toLocaleString()}>
          <Grid item className="update-date">
            <span>{media.ref.updated_age}</span>
          </Grid>
        </Tooltip>
        <Grid item>
          {canEdit && <LockAction id={media.id} lock={media.lock_media_to_project} />}
          <AdvancedActionCell>
            {canDelete && <DeleteAction itemId={media.id} />}
            {media.ref.video && canView && <DownloadVideoAction video={media.ref.video} />}
            {media.ref.video && canView && <ExportMediaAction media={media} />}
            {!(media.ref.video && canView) && <DownloadDocumentAction document={media.ref.document} />}
            {isSuperAdmin && media.ref.video && canView && <RequestMasterAction video={media.ref.video} />}
          </AdvancedActionCell>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MediaVideo;
